/**
 * Maps a PostgreSQL term to a corresponding Algolia facet type.
 *
 * @param {string} postgresTerm - The PostgreSQL term to be mapped.
 * @returns {string} The corresponding Algolia facet type.
 */
const mapPostgresTermWithAlogliaFacetType = (postgresTerm) => {
  switch (postgresTerm) {
    case 'activity':
      return 'off_site_activities'
    case 'treatment_therapy':
      return 'treatment_therapies'
    case 'treatment_method':
      return 'treatment_methods'
    default:
      return postgresTerm
  }
}

export default mapPostgresTermWithAlogliaFacetType
